module.exports = __webpack_public_path__ + "img/226.problem_air_condition.e454e494.svg";